module.exports = __webpack_public_path__ + "img/cover.dae3da72.jpg";